import React from 'react';
import { motion } from 'framer-motion';
export function ManifestoSection() {
  return <section className="py-24 lg:py-32 bg-gradient-to-b from-navy-900 via-navy-800 to-charcoal relative overflow-hidden" data-id="element-380">
      {/* Subtle dot pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" data-id="element-381">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-382"></div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-383">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-384">
          <div className="mb-8 flex flex-col items-start" data-id="element-385">
            <div className="w-12 h-px bg-gold mb-4" data-id="element-386"></div>
            <span className="text-emerald-400 text-xs font-bold tracking-widest uppercase" data-id="element-387">
              Editorial Position
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-serif text-white mb-10 tracking-tight leading-tight" data-id="element-388">
            Most Credit Advice Ignores How Bureau Reporting Actually Works
          </h2>

          <div className="space-y-8 text-lg text-slate-100/95 leading-[1.85] font-medium" data-id="element-389">
            <p data-id="element-390">
              Traditional credit-repair marketing is built around speed claims,
              outsourced disputes, and vague promises. Consumers pay monthly
              retainers while receiving little visibility into what was
              challenged, how bureaus responded, or whether investigations
              followed federal standards. Most consumers learn this the hard way
              — after months of paying for something that was supposed to be
              working.
            </p>

            <p data-id="element-391">
              Institutional skepticism toward bureau data means treating credit
              reports as financial records that deserve verification, not blind
              trust. The three major bureaus routinely display conflicting
              account histories, inconsistent balances, and mismatched reporting
              timelines across the same consumer file. CFPB complaint records
              show these inconsistencies are not isolated events.
            </p>

            <p data-id="element-392">
              Blinkblis operates as an editorial research and monitoring
              platform, not a credit-repair operation. Every analysis is tied to
              public-source evidence, federal statutes, or documented reporting
              patterns from CFPB complaints, FTC enforcement actions, and FCRA
              litigation records. The goal is simple: help consumers understand
              what they are seeing before they decide how to respond.
            </p>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10" data-id="element-393">
            <p className="text-slate-200/90 italic text-base leading-relaxed" data-id="element-394">
              The framework below explains how experienced consumers approach
              bureau reporting problems systematically — patterns most people
              only notice after they've already been denied.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}